module.exports = __webpack_public_path__ + "static/img/charlie-sweating.aa309f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/charlie-sweating.jpg
// module id = DpDp
// module chunks = 1